import NotificationTemplate from './NotificationTemplate';
export default NotificationTemplate;
